import { render, staticRenderFns } from "./CityDetails.vue?vue&type=template&id=5234a9e8&scoped=true"
import script from "./CityDetails.vue?vue&type=script&lang=js"
export * from "./CityDetails.vue?vue&type=script&lang=js"
import style0 from "./CityDetails.vue?vue&type=style&index=0&id=5234a9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5234a9e8",
  null
  
)

export default component.exports